import { jsx, Keyframes, SerializedStyles } from "@emotion/react";
import styled from "@emotion/styled";
import React, { forwardRef } from "react";
import { ThemeProp } from "../../styles/theme";
import { GlobalStore } from "../../store/global/GlobalStore";
import IntrinsicElements = jsx.JSX.IntrinsicElements;

export enum AnimationState {
  Opening = "opening",
  Closing = "closing",
  None = "none",
}

export interface AnimatedDivProps extends ThemeProp {
  animationState: AnimationState; // Define AnimationState type if not defined elsewhere
  duration: number;
  animatedDivCss?: SerializedStyles;
  openingAnimation: Keyframes;
  closingAnimation: Keyframes;
}

export const AnimatedDiv = styled.div<AnimatedDivProps>`
  ${props => props.animatedDivCss};
  animation: ${props =>
      props.animationState === AnimationState.Opening
        ? props.openingAnimation
        : props.closingAnimation}
    ${props => props.duration}ms ease forwards;
`;

interface AnimatedComponentProps {
  childContainerProps?: Partial<IntrinsicElements["div"]>;
  animationState: AnimationState;
  openingAnimation: Keyframes;
  closingAnimation: Keyframes;
  duration: number;
  children?: React.ReactNode;
}

const AnimatedDropdownContent = forwardRef<HTMLDivElement, AnimatedComponentProps>(
  (
    { childContainerProps, animationState, openingAnimation, closingAnimation, duration, children },
    ref
  ) => {
    const theme = GlobalStore.useState(s => s.theme);
    return (
      <AnimatedDiv
        {...childContainerProps}
        openingAnimation={openingAnimation}
        closingAnimation={closingAnimation}
        theme={theme}
        animationState={animationState}
        duration={duration}
        ref={ref}
      >
        {children}
      </AnimatedDiv>
    );
  }
);

export default AnimatedDropdownContent;
